import {CapsulableEntity, EntityCapsule, EntityCapsuleProps} from "../entity/capsule.tsx";
import {iconForEntityType} from "../fa.tsx";

export interface VenueCapsuleProps extends Omit<EntityCapsuleProps, "entity"> {
    venue: CapsulableEntity;
}

export function VenueCapsule(props: VenueCapsuleProps) {
    const {venue, ...rest} = props;
    if (!venue.icon) {
        venue.icon = iconForEntityType("venue");
    }
    return <EntityCapsule entity={venue} {...rest}/>
}


